export const storeEditorialFields = [
  { key: "sidebarContent", label: "Sidebar" },
  { key: "aboutStore", label: "About Store" },
  { key: "whyTrustUs", label: "Why Trust Us" },
  { key: "waysToSave", label: "Ways to Save" },
  { key: "storeInformation", label: "Store information" },
  { key: "howToRedeem", label: "How to redeem a coupon" },
  { key: "shippingInformation", label: "Shipping information" },
  { key: "returnsInformation", label: "Returns information" },
] as const;
export type StoreEditorialKey = typeof storeEditorialFields[number]["key"];
export type StoreFAQ = { question: string; answer: string };
export type StoreEditorial = Partial<Record<StoreEditorialKey, string>> & { featuredContent?: string; faqs?: StoreFAQ[] };

// Only include submitted fields so unrelated edits preserve existing content.
export function pickStoreEditorial(data: StoreEditorial): StoreEditorial {
  const result: StoreEditorial = {};
  if (typeof data.featuredContent === "string") result.featuredContent = data.featuredContent.trim();
  for (const { key } of storeEditorialFields) {
    if (typeof data[key] === "string") result[key] = data[key]!.trim();
  }
  if (Array.isArray(data.faqs)) result.faqs = data.faqs.map(({ question, answer }) => ({ question: question.trim(), answer: answer.trim() }));
  return result;
}
export function resolveStoreName(text: string, name: string): string {
  return text.replace(/\{\{\s*storeName\s*\}\}/gi, () => name);
}
export function resolveStoreHtml(text: string, name: string): string {
  const escaped = name.replace(/[&<>"']/g, character => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[character]!));
  return resolveStoreName(text, escaped);
}
